import { t } from 'state/intl/translations';

export enum JoinType {
  CONJUCTION = 'CONJUCTION',
  DISJUNCTION = 'DISJUNCTION',
}

interface IFormatListOfWords {
  list: string[];
  joinType: JoinType;
}

/**
 * formatListOfWords: This function allows you to join list of words together in a safe way.
 * @param words List of words to be concatenated.
 * @returns Enumaration string composed by words and its separators.
 */
export default function formatListOfWords({ list, joinType }: IFormatListOfWords): string {
  return list
    .map((word, index) => {
      const key = joinType === JoinType.DISJUNCTION ? 'listOfWordsLayoutOr' : 'listOfWordsLayout';
      return t(key, {
        word,
        position: getWordPositionInList(index + 1, list.length),
      });
    })
    .join('');
}

function getWordPositionInList(wordNumberPosition: number, wordsAmount: number): string {
  if (wordNumberPosition === wordsAmount && wordsAmount > 1) {
    return 'last';
  }

  if (wordNumberPosition === 1) {
    return 'first';
  }

  return 'inner';
}
